import { w as o } from "./components/BaseIcon/icons/1x.svg_raw-DIzBMlg4.js";
import { w as r } from "./components/BaseIcon/icons/2x.svg_raw-CqtGFgYw.js";
import { w as a } from "./components/BaseIcon/icons/4x.svg_raw-DWS3__ya.js";
import { w as t } from "./components/BaseIcon/icons/activity.svg_raw-BnyobyRC.js";
import { w as m } from "./components/BaseIcon/icons/add-comment.svg_raw-BYzrnHIe.js";
import { w as i } from "./components/BaseIcon/icons/add-comments-round-alt.svg_raw-_ECJgPqU.js";
import { w } from "./components/BaseIcon/icons/add-new.svg_raw-CiyJ-3-S.js";
import { w as e } from "./components/BaseIcon/icons/add-panel.svg_raw-BH7c6rJU.js";
import { w as s } from "./components/BaseIcon/icons/add-reaction.svg_raw-DCdwDJng.js";
import { w as _ } from "./components/BaseIcon/icons/add-to-report.svg_raw-BFabCt0j.js";
import { w as p } from "./components/BaseIcon/icons/admin-shield-safe.svg_raw-DMcAZg5V.js";
import { w as b } from "./components/BaseIcon/icons/agent-stop.svg_raw-Bmm2wz2P.js";
import { w as l } from "./components/BaseIcon/icons/alias-alt.svg_raw-CZFumkMw.js";
import { w as f } from "./components/BaseIcon/icons/alias-protected.svg_raw-BXb3BlWT.js";
import { w as n } from "./components/BaseIcon/icons/amazon-sagemaker.svg_raw-BZXMIfr-.js";
import { w as c } from "./components/BaseIcon/icons/aperture.svg_raw-DyFPsX2Y.js";
import { w as d } from "./components/BaseIcon/icons/apps.svg_raw-BLvVW5e7.js";
import { w as u } from "./components/BaseIcon/icons/arrow-up-from-line.svg_raw-BW5hbVqc.js";
import { w as h } from "./components/BaseIcon/icons/artifact-type.svg_raw-O1e0c3_6.js";
import { w as g } from "./components/BaseIcon/icons/artifact-type-alt.svg_raw-qgul9uPA.js";
import { w as k } from "./components/BaseIcon/icons/attachment.svg_raw-CkC0ZoyE.js";
import { w as y } from "./components/BaseIcon/icons/audio-volume.svg_raw-2dWDfOJ4.js";
import { w as v } from "./components/BaseIcon/icons/automation-robot-arm.svg_raw-BqXbTJQC.js";
import { w as x } from "./components/BaseIcon/icons/baby.svg_raw-CE2JLu2Y.js";
import { w as z } from "./components/BaseIcon/icons/back.svg_raw--1uQ7SS1.js";
import { w as j } from "./components/BaseIcon/icons/baseline-alt.svg_raw-Djt9XUjS.js";
import { w as q } from "./components/BaseIcon/icons/bell-notifications.svg_raw-DTpWm9NI.js";
import { w as I } from "./components/BaseIcon/icons/benchmark-square.svg_raw-Cc_q7Plb.js";
import { w as A } from "./components/BaseIcon/icons/bike.svg_raw-CXsbJjXQ.js";
import { w as C } from "./components/BaseIcon/icons/blog-alt.svg_raw-Bl9QRVb8.js";
import { w as M } from "./components/BaseIcon/icons/blog-report.svg_raw-CYzphKCu.js";
import { w as N } from "./components/BaseIcon/icons/bokeh.svg_raw-Du4BItaZ.js";
import { w as O } from "./components/BaseIcon/icons/bold.svg_raw-CzC6yac-.js";
import { w as P } from "./components/BaseIcon/icons/book-dictionary.svg_raw-op5qc4Rg.js";
import { w as B } from "./components/BaseIcon/icons/bookmark.svg_raw-BeWZocDH.js";
import { w as D } from "./components/BaseIcon/icons/bookmark-filled.svg_raw-B21OMUyO.js";
import { w as E } from "./components/BaseIcon/icons/bookmark-my-projects.svg_raw-B7bEdglC.js";
import { w as F } from "./components/BaseIcon/icons/brain-circuit.svg_raw-Btp2FkRz.js";
import { w as G } from "./components/BaseIcon/icons/branch-commit.svg_raw-CNnnQiy8.js";
import { w as H } from "./components/BaseIcon/icons/bug.svg_raw-DZ4l7cZn.js";
import { w as J } from "./components/BaseIcon/icons/bulk-panel-alt.svg_raw-sQMQ1Fh4.js";
import { w as K } from "./components/BaseIcon/icons/buzz-bot.svg_raw-Dra--5X3.js";
import { w as L } from "./components/BaseIcon/icons/camera-photo.svg_raw-CSmR9i95.js";
import { w as Q } from "./components/BaseIcon/icons/caret-close.svg_raw-g6xmvSnR.js";
import { w as R } from "./components/BaseIcon/icons/caret-open.svg_raw-D_YgurJO.js";
import { w as S } from "./components/BaseIcon/icons/category-multimodal.svg_raw-F09L0Xm1.js";
import { w as T } from "./components/BaseIcon/icons/chart-area.svg_raw-Cn0iiivz.js";
import { w as U } from "./components/BaseIcon/icons/chart-area-alt.svg_raw-7PdDG28T.js";
import { w as V } from "./components/BaseIcon/icons/chart-area-percentage.svg_raw-CLXaN4-f.js";
import { w as W } from "./components/BaseIcon/icons/chart-box-plot.svg_raw-Cfotp4tR.js";
import { w as X } from "./components/BaseIcon/icons/chart-ema-exponential.svg_raw-BTJZHU5a.js";
import { w as Y } from "./components/BaseIcon/icons/chart-horizontal-bars.svg_raw-B85YcCWL.js";
import { w as Z } from "./components/BaseIcon/icons/chart-line.svg_raw-V3uxAnSZ.js";
import { w as $ } from "./components/BaseIcon/icons/chart-line-plot.svg_raw-By5jcWYY.js";
import { w as oo } from "./components/BaseIcon/icons/chart-line-plot-down.svg_raw-DRUzr4T5.js";
import { w as ro } from "./components/BaseIcon/icons/chart-line-plot-multi.svg_raw-D1vXZGU4.js";
import { w as ao } from "./components/BaseIcon/icons/chart-linear-scale.svg_raw-BN3O2JQP.js";
import { w as to } from "./components/BaseIcon/icons/chart-loess.svg_raw-BdctM08C.js";
import { w as mo } from "./components/BaseIcon/icons/chart-logarithmic.svg_raw-Be3SqPIA.js";
import { w as io } from "./components/BaseIcon/icons/chart-parallel-coordinates.svg_raw-DCtnvuje.js";
import { w as wo } from "./components/BaseIcon/icons/chart-pie.svg_raw-u9OKPFZn.js";
import { w as eo } from "./components/BaseIcon/icons/chart-scatterplot.svg_raw-BDsk6mTy.js";
import { w as so } from "./components/BaseIcon/icons/chart-time-weighted-ema.svg_raw-Be47qGOQ.js";
import { w as _o } from "./components/BaseIcon/icons/chart-vertical-bars.svg_raw-C5qhLkYg.js";
import { w as po } from "./components/BaseIcon/icons/checkmark.svg_raw-EI6AQGfg.js";
import { w as bo } from "./components/BaseIcon/icons/checkmark-alt.svg_raw-DYEKnLsX.js";
import { w as lo } from "./components/BaseIcon/icons/checkmark-circle.svg_raw-CLjLW4EE.js";
import { w as fo } from "./components/BaseIcon/icons/checkmark2.svg_raw-BR9IZARc.js";
import { w as no } from "./components/BaseIcon/icons/chevron-back.svg_raw-yi7Zag9z.js";
import { w as co } from "./components/BaseIcon/icons/chevron-down.svg_raw-CKMuc6bv.js";
import { w as uo } from "./components/BaseIcon/icons/chevron-next.svg_raw-B1pErEaT.js";
import { w as ho } from "./components/BaseIcon/icons/chevron-up.svg_raw-tXYPs5ON.js";
import { w as go } from "./components/BaseIcon/icons/circle.svg_raw-Dog3Fxt9.js";
import { w as ko } from "./components/BaseIcon/icons/circle-bold.svg_raw-DaCKHhcA.js";
import { w as yo } from "./components/BaseIcon/icons/circle-dollar-sign.svg_raw-DaWWbKxa.js";
import { w as vo } from "./components/BaseIcon/icons/circle-filled.svg_raw-CO7HNVld.js";
import { w as xo } from "./components/BaseIcon/icons/clear-all.svg_raw-D5TwIKvx.js";
import { w as zo } from "./components/BaseIcon/icons/close.svg_raw-C5pzqUee.js";
import { w as jo } from "./components/BaseIcon/icons/cloud.svg_raw-BdYfmkdd.js";
import { w as qo } from "./components/BaseIcon/icons/cloud-download.svg_raw-D6zMV_I8.js";
import { w as Io } from "./components/BaseIcon/icons/cloud-upload.svg_raw-DQgfyGvM.js";
import { w as Ao } from "./components/BaseIcon/icons/code-alt.svg_raw-DipkW599.js";
import { w as Co } from "./components/BaseIcon/icons/code-html.svg_raw-CR0HRy9G.js";
import { w as Mo } from "./components/BaseIcon/icons/code-json.svg_raw-BjgarSd5.js";
import { w as No } from "./components/BaseIcon/icons/colab.svg_raw-DvdN7MPy.js";
import { w as Oo } from "./components/BaseIcon/icons/collapse.svg_raw-Bi-Ye4ep.js";
import { w as Po } from "./components/BaseIcon/icons/collection.svg_raw-DRd1WLGA.js";
import { w as Bo } from "./components/BaseIcon/icons/color.svg_raw-BxYysyUD.js";
import { w as Do } from "./components/BaseIcon/icons/color-palette.svg_raw-BLVJmMDK.js";
import { w as Eo } from "./components/BaseIcon/icons/column.svg_raw-BQaHdJye.js";
import { w as Fo } from "./components/BaseIcon/icons/column-alt.svg_raw-CA1ffxzB.js";
import { w as Go } from "./components/BaseIcon/icons/combine.svg_raw-Dycxz-Tj.js";
import { w as Ho } from "./components/BaseIcon/icons/comments.svg_raw-BsSpn7HN.js";
import { w as Jo } from "./components/BaseIcon/icons/comments-alt.svg_raw-BaVvE-EU.js";
import { w as Ko } from "./components/BaseIcon/icons/comments-round-alt.svg_raw-CPOGC08L.js";
import { w as Lo } from "./components/BaseIcon/icons/compass-baseline.svg_raw-B2_AgN_X.js";
import { w as Qo } from "./components/BaseIcon/icons/compass-baseline-alt.svg_raw-CjJHWM_y.js";
import { w as Ro } from "./components/BaseIcon/icons/compose.svg_raw-Hg78QwjN.js";
import { w as So } from "./components/BaseIcon/icons/condition.svg_raw-BfWbc3t2.js";
import { w as To } from "./components/BaseIcon/icons/content-full-width.svg_raw-DItYd8dR.js";
import { w as Uo } from "./components/BaseIcon/icons/content-narrow.svg_raw-CW93y7N4.js";
import { w as Vo } from "./components/BaseIcon/icons/content-wide.svg_raw-BOC8EUkA.js";
import { w as Wo } from "./components/BaseIcon/icons/context-window.svg_raw-C3ER3Zz0.js";
import { w as Xo } from "./components/BaseIcon/icons/copy.svg_raw-BZaLVpFs.js";
import { w as Yo } from "./components/BaseIcon/icons/cost.svg_raw-Be1Et0GA.js";
import { w as Zo } from "./components/BaseIcon/icons/courthouse-license.svg_raw-BiqHkGJD.js";
import { w as $o } from "./components/BaseIcon/icons/credit-card-payment.svg_raw-CvtUq_48.js";
import { w as or } from "./components/BaseIcon/icons/crop-beginning.svg_raw-CuHkUike.js";
import { w as rr } from "./components/BaseIcon/icons/crop-end.svg_raw-Dl6QFQbU.js";
import { w as ar } from "./components/BaseIcon/icons/crop-middle.svg_raw-BZZa-VX7.js";
import { w as tr } from "./components/BaseIcon/icons/cross.svg_raw-4Fs9SzPb.js";
import { w as mr } from "./components/BaseIcon/icons/crown-pro.svg_raw-CONFuuXh.js";
import { w as ir } from "./components/BaseIcon/icons/cube-container.svg_raw-D4IJs01T.js";
import { w as wr } from "./components/BaseIcon/icons/curly-brackets.svg_raw-BYRJyg59.js";
import { w as er } from "./components/BaseIcon/icons/dag.svg_raw-DjXl0Sel.js";
import { w as sr } from "./components/BaseIcon/icons/dashboard-blackboard.svg_raw-CWeAitxZ.js";
import { w as _r } from "./components/BaseIcon/icons/database-artifacts.svg_raw-DR2bIKgI.js";
import { w as pr } from "./components/BaseIcon/icons/date.svg_raw-D6Bz7Z-8.js";
import { w as br } from "./components/BaseIcon/icons/delete.svg_raw-DNWhgBv2.js";
import { w as lr } from "./components/BaseIcon/icons/desktop-responsive.svg_raw-B6zUnsTe.js";
import { w as fr } from "./components/BaseIcon/icons/diamond.svg_raw-BckeGRl5.js";
import { w as nr } from "./components/BaseIcon/icons/diamond-pro.svg_raw-B91hTyAT.js";
import { w as cr } from "./components/BaseIcon/icons/diff.svg_raw-Bodrpy3I.js";
import { w as dr } from "./components/BaseIcon/icons/discord-social.svg_raw-BiNVIom1.js";
import { w as ur } from "./components/BaseIcon/icons/do-not-prohibited.svg_raw-DNw3ozoc.js";
import { w as hr } from "./components/BaseIcon/icons/doc-left.svg_raw-QR-aXWny.js";
import { w as gr } from "./components/BaseIcon/icons/dock-arrow.svg_raw-BfVcMo5i.js";
import { w as kr } from "./components/BaseIcon/icons/docker-whale.svg_raw-B41Gl6Xp.js";
import { w as yr } from "./components/BaseIcon/icons/document.svg_raw-DKNynJRK.js";
import { w as vr } from "./components/BaseIcon/icons/documentation.svg_raw-Cia3Kbgu.js";
import { w as xr } from "./components/BaseIcon/icons/down.svg_raw-Dgw4rK47.js";
import { w as zr } from "./components/BaseIcon/icons/download.svg_raw-BIVI9zsm.js";
import { w as jr } from "./components/BaseIcon/icons/draft-manual.svg_raw-DP9bcIBI.js";
import { w as qr } from "./components/BaseIcon/icons/drag-grip.svg_raw-BtaDPZmn.js";
import { w as Ir } from "./components/BaseIcon/icons/dumbbell.svg_raw-G-QRa30J.js";
import { w as Ar } from "./components/BaseIcon/icons/education-academic.svg_raw-D46Qi3in.js";
import { w as Cr } from "./components/BaseIcon/icons/email-at.svg_raw-CYJxil8v.js";
import { w as Mr } from "./components/BaseIcon/icons/email-envelope.svg_raw-Dp76_50Q.js";
import { w as Nr } from "./components/BaseIcon/icons/enter-return.svg_raw-DST6Qi3Y.js";
import { w as Or } from "./components/BaseIcon/icons/enter-switch.svg_raw-bnQVFklT.js";
import { w as Pr } from "./components/BaseIcon/icons/enterprise-corporate.svg_raw-CcK3UO21.js";
import { w as Br } from "./components/BaseIcon/icons/expand-down.svg_raw-hYyhw-qe.js";
import { w as Dr } from "./components/BaseIcon/icons/expand-left.svg_raw-GYt1Pr5E.js";
import { w as Er } from "./components/BaseIcon/icons/expand-right.svg_raw-BQtLZ5Cy.js";
import { w as Fr } from "./components/BaseIcon/icons/expand-uncollapse.svg_raw-Dv62CSJb.js";
import { w as Gr } from "./components/BaseIcon/icons/expand-up.svg_raw-D9iA5WEP.js";
import { w as Hr } from "./components/BaseIcon/icons/explosion.svg_raw-C9q2UC5Z.js";
import { w as Jr } from "./components/BaseIcon/icons/export-share-upload.svg_raw-Drz9-c25.js";
import { w as Kr } from "./components/BaseIcon/icons/extract.svg_raw-BRBsdiZl.js";
import { w as Lr } from "./components/BaseIcon/icons/extract-break.svg_raw-C5NtylZ_.js";
import { w as Qr } from "./components/BaseIcon/icons/facebook-social.svg_raw-CP5M4FdL.js";
import { w as Rr } from "./components/BaseIcon/icons/factory.svg_raw-BVvQwAPP.js";
import { w as Sr } from "./components/BaseIcon/icons/failed-error-deleted.svg_raw-DubKqjfg.js";
import { w as Tr } from "./components/BaseIcon/icons/feather.svg_raw-Dos1ccHm.js";
import { w as Ur } from "./components/BaseIcon/icons/feather-alt.svg_raw-Thv68IlY.js";
import { w as Vr } from "./components/BaseIcon/icons/filter-alt.svg_raw-CuvnfQfY.js";
import { w as Wr } from "./components/BaseIcon/icons/flash-bolt.svg_raw-BmiQX59z.js";
import { w as Xr } from "./components/BaseIcon/icons/folder-eye.svg_raw-BvBNvdGy.js";
import { w as Yr } from "./components/BaseIcon/icons/folder-fill.svg_raw-CexyqSzX.js";
import { w as Zr } from "./components/BaseIcon/icons/folder-project.svg_raw-DtKRcH8i.js";
import { w as $r } from "./components/BaseIcon/icons/folder-project-move.svg_raw-ywlqZYNT.js";
import { w as oa } from "./components/BaseIcon/icons/footprints.svg_raw-C-ewin1v.js";
import { w as ra } from "./components/BaseIcon/icons/forum-chat-bubble.svg_raw-V3yUQYwX.js";
import { w as aa } from "./components/BaseIcon/icons/forward-next.svg_raw-C5_9UXPG.js";
import { w as ta } from "./components/BaseIcon/icons/freeze-snowflake.svg_raw-CqmBb98m.js";
import { w as ma } from "./components/BaseIcon/icons/freeze-snowflake-alt.svg_raw-Bot1Gn7j.js";
import { w as ia } from "./components/BaseIcon/icons/full-screen-mode-expand.svg_raw-BYcw8HiR.js";
import { w as wa } from "./components/BaseIcon/icons/ghost-agent.svg_raw-RBTopzZE.js";
import { w as ea } from "./components/BaseIcon/icons/git.svg_raw-bKtbE7Z-.js";
import { w as sa } from "./components/BaseIcon/icons/github.svg_raw-CkIf-lIk.js";
import { w as _a } from "./components/BaseIcon/icons/grafana.svg_raw-DsXHbzDj.js";
import { w as pa } from "./components/BaseIcon/icons/grafana-mono.svg_raw-DHKLjlyA.js";
import { w as ba } from "./components/BaseIcon/icons/group.svg_raw-Dt8fzC1P.js";
import { w as la } from "./components/BaseIcon/icons/hand-fist.svg_raw-Cgb7GEv3.js";
import { w as fa } from "./components/BaseIcon/icons/hand-manual.svg_raw-BzGBnQAX.js";
import { w as na } from "./components/BaseIcon/icons/headset.svg_raw-BKmA7E_9.js";
import { w as ca } from "./components/BaseIcon/icons/heart.svg_raw-ByRIMT0-.js";
import { w as da } from "./components/BaseIcon/icons/heart-filled.svg_raw-DDYZqESC.js";
import { w as ua } from "./components/BaseIcon/icons/help-alt.svg_raw-RzyAtjl1.js";
import { w as ha } from "./components/BaseIcon/icons/help-resources.svg_raw-itXv0vUT.js";
import { w as ga } from "./components/BaseIcon/icons/hide.svg_raw-CNBQyirl.js";
import { w as ka } from "./components/BaseIcon/icons/history.svg_raw-Dod2SZc6.js";
import { w as ya } from "./components/BaseIcon/icons/home.svg_raw-BgkS6gNI.js";
import { w as va } from "./components/BaseIcon/icons/hospital.svg_raw-D5cy8kN6.js";
import { w as xa } from "./components/BaseIcon/icons/hourglass.svg_raw-DxgVQVv7.js";
import { w as za } from "./components/BaseIcon/icons/hourglass-alt.svg_raw-CKZk_JSE.js";
import { w as ja } from "./components/BaseIcon/icons/idle.svg_raw-CCQVJl1z.js";
import { w as qa } from "./components/BaseIcon/icons/ignore-outliers.svg_raw-BRC035Wv.js";
import { w as Ia } from "./components/BaseIcon/icons/impersonate-mask.svg_raw-BHMfui1g.js";
import { w as Aa } from "./components/BaseIcon/icons/impersonate-mask-alt.svg_raw-Chz7ICpr.js";
import { w as Ca } from "./components/BaseIcon/icons/import-corner-arrow.svg_raw-CDE0x-TW.js";
import { w as Ma } from "./components/BaseIcon/icons/import-insert.svg_raw-I5wIt7YP.js";
import { w as Na } from "./components/BaseIcon/icons/individual-controls-alt.svg_raw-D3kZdrdR.js";
import { w as Oa } from "./components/BaseIcon/icons/inference.svg_raw-2AMly6M6.js";
import { w as Pa } from "./components/BaseIcon/icons/infinity-auto.svg_raw-CSoca8jV.js";
import { w as Ba } from "./components/BaseIcon/icons/info.svg_raw-CYIzhEnO.js";
import { w as Da } from "./components/BaseIcon/icons/isolate.svg_raw-fH-P_y_f.js";
import { w as Ea } from "./components/BaseIcon/icons/italic.svg_raw-CXn9HAQK.js";
import { w as Fa } from "./components/BaseIcon/icons/job-automation.svg_raw-y7DKRfUs.js";
import { w as Ga } from "./components/BaseIcon/icons/job-calculator.svg_raw-kmabFhfJ.js";
import { w as Ha } from "./components/BaseIcon/icons/job-program-code.svg_raw-BhyVkr6A.js";
import { w as Ja } from "./components/BaseIcon/icons/keras.svg_raw-B-2p-P0e.js";
import { w as Ka } from "./components/BaseIcon/icons/key-admin.svg_raw-CoGkK0ec.js";
import { w as La } from "./components/BaseIcon/icons/key-admin-private.svg_raw-q3qcS0wI.js";
import { w as Qa } from "./components/BaseIcon/icons/keyboard.svg_raw-DW0MRCui.js";
import { w as Ra } from "./components/BaseIcon/icons/kubernetes.svg_raw-yHFmfj8S.js";
import { w as Sa } from "./components/BaseIcon/icons/languages.svg_raw-r309g7vt.js";
import { w as Ta } from "./components/BaseIcon/icons/laptop-local-computer.svg_raw-Dw368mQ1.js";
import { w as Ua } from "./components/BaseIcon/icons/layout-grid.svg_raw-BLvVW5e7.js";
import { w as Va } from "./components/BaseIcon/icons/layout-horizontal.svg_raw-C8Vr4za5.js";
import { w as Wa } from "./components/BaseIcon/icons/layout-mixed.svg_raw-F-lQK9Co.js";
import { w as Xa } from "./components/BaseIcon/icons/layout-split.svg_raw-BzxKpsZc.js";
import { w as Ya } from "./components/BaseIcon/icons/layout-tabs.svg_raw-5WSzQhFy.js";
import { w as Za } from "./components/BaseIcon/icons/layout-vertical.svg_raw-cTPkAUK6.js";
import { w as $a } from "./components/BaseIcon/icons/leaf.svg_raw-CROoHSd3.js";
import { w as ot } from "./components/BaseIcon/icons/lightboard.svg_raw-GQM7c_KZ.js";
import { w as rt } from "./components/BaseIcon/icons/lightboard-solid.svg_raw-ErbDE7dp.js";
import { w as at } from "./components/BaseIcon/icons/lightbulb-info.svg_raw-CQ4s2qcv.js";
import { w as tt } from "./components/BaseIcon/icons/linear-scale-1.svg_raw-DPQyaB_d.js";
import { w as mt } from "./components/BaseIcon/icons/link-alt.svg_raw-DXNNHzIB.js";
import { w as it } from "./components/BaseIcon/icons/list-bullets.svg_raw-Dy9c9lQB.js";
import { w as wt } from "./components/BaseIcon/icons/list-bullets-alt.svg_raw-CozffRJ1.js";
import { w as et } from "./components/BaseIcon/icons/list-numbered.svg_raw-BzgIytZQ.js";
import { w as st } from "./components/BaseIcon/icons/listing.svg_raw-ywV7Os8E.js";
import { w as _t } from "./components/BaseIcon/icons/loading.svg_raw-LWDJSa5u.js";
import { w as pt } from "./components/BaseIcon/icons/location-pin.svg_raw-DxvbC5Be.js";
import { w as bt } from "./components/BaseIcon/icons/lock-closed.svg_raw-Do1N_izg.js";
import { w as lt } from "./components/BaseIcon/icons/lock-open.svg_raw-78OC2DAt.js";
import { w as ft } from "./components/BaseIcon/icons/locked-constrained.svg_raw-B1VU_Qdr.js";
import { w as nt } from "./components/BaseIcon/icons/log-in.svg_raw-zuUSET8z.js";
import { w as ct } from "./components/BaseIcon/icons/log-out.svg_raw-BrBC_Zwj.js";
import { w as dt } from "./components/BaseIcon/icons/log-scale-x.svg_raw-Abq4zoeD.js";
import { w as ut } from "./components/BaseIcon/icons/log-scale-y.svg_raw-COa_vglI.js";
import { w as ht } from "./components/BaseIcon/icons/magic-wand-star.svg_raw-QCZBQt_R.js";
import { w as gt } from "./components/BaseIcon/icons/magic-wand-stick.svg_raw-C5Vhf77v.js";
import { w as kt } from "./components/BaseIcon/icons/marimo.svg_raw-DRMTtgOB.js";
import { w as yt } from "./components/BaseIcon/icons/marker.svg_raw-CcW95_qk.js";
import { w as vt } from "./components/BaseIcon/icons/megaphone.svg_raw-k_M4xdgV.js";
import { w as xt } from "./components/BaseIcon/icons/menu.svg_raw-BtPlkNk5.js";
import { w as zt } from "./components/BaseIcon/icons/microphone-audio.svg_raw-B1KJ_TlI.js";
import { w as jt } from "./components/BaseIcon/icons/miller-columns.svg_raw-OKUhbk85.js";
import { w as qt } from "./components/BaseIcon/icons/minimize-mode.svg_raw-DF1FhMU-.js";
import { w as It } from "./components/BaseIcon/icons/mobile-responsive.svg_raw-Dm6jm4bh.js";
import { w as At } from "./components/BaseIcon/icons/model.svg_raw-DnY4NYQu.js";
import { w as Ct } from "./components/BaseIcon/icons/molecule.svg_raw-By3VMCwT.js";
import { w as Mt } from "./components/BaseIcon/icons/monitors.svg_raw-vkz9YE-x.js";
import { w as Nt } from "./components/BaseIcon/icons/moon.svg_raw-YicgVjf1.js";
import { w as Ot } from "./components/BaseIcon/icons/multi-select.svg_raw-Cm_RFTqg.js";
import { w as Pt } from "./components/BaseIcon/icons/music-audio.svg_raw-Dnd4TCFq.js";
import { w as Bt } from "./components/BaseIcon/icons/new-section-above.svg_raw-CaDMI8GQ.js";
import { w as Dt } from "./components/BaseIcon/icons/new-section-below.svg_raw-CfcIhjVx.js";
import { w as Et } from "./components/BaseIcon/icons/notebook.svg_raw-BGyWQNjB.js";
import { w as Ft } from "./components/BaseIcon/icons/number-hashtag.svg_raw-CALw7htf.js";
import { w as Gt } from "./components/BaseIcon/icons/open-new-tab.svg_raw-CNP508SG.js";
import { w as Ht } from "./components/BaseIcon/icons/orchestration-launch.svg_raw-cJBF4UiC.js";
import { w as Jt } from "./components/BaseIcon/icons/organization-corporate.svg_raw-Bn3yciLk.js";
import { w as Kt } from "./components/BaseIcon/icons/overflow-horizontal.svg_raw-LLmAvJTS.js";
import { w as Lt } from "./components/BaseIcon/icons/pan-tool.svg_raw-ClW_KXyW.js";
import { w as Qt } from "./components/BaseIcon/icons/pan-tool-1.svg_raw-CCub9XHi.js";
import { w as Rt } from "./components/BaseIcon/icons/panel.svg_raw-Ca76STAd.js";
import { w as St } from "./components/BaseIcon/icons/panel-auto-gen.svg_raw-BlzejGwJ.js";
import { w as Tt } from "./components/BaseIcon/icons/panel-hide-icon-closed-eye.svg_raw-Cf4SZSsp.js";
import { w as Ut } from "./components/BaseIcon/icons/panel-manual.svg_raw-DPyRpnWf.js";
import { w as Vt } from "./components/BaseIcon/icons/paragraph.svg_raw-BRqJ_hZL.js";
import { w as Wt } from "./components/BaseIcon/icons/parent-back-up.svg_raw-_8etpNwh.js";
import { w as Xt } from "./components/BaseIcon/icons/party-popper.svg_raw-Dd-PPOqU.js";
import { w as Yt } from "./components/BaseIcon/icons/pause.svg_raw-DP3MBuTh.js";
import { w as Zt } from "./components/BaseIcon/icons/paused.svg_raw-M41ysSlX.js";
import { w as $t } from "./components/BaseIcon/icons/pencil-edit.svg_raw-DZrqZ83h.js";
import { w as om } from "./components/BaseIcon/icons/phone.svg_raw-BRmUU9Rw.js";
import { w as rm } from "./components/BaseIcon/icons/photo-picture.svg_raw-Dq7mhvYW.js";
import { w as am } from "./components/BaseIcon/icons/pin.svg_raw-CgZM3V0X.js";
import { w as tm } from "./components/BaseIcon/icons/pin-filled.svg_raw-CHAVMOuY.js";
import { w as mm } from "./components/BaseIcon/icons/plane.svg_raw-BeBRXHqe.js";
import { w as im } from "./components/BaseIcon/icons/play.svg_raw-Bgf4D5Pj.js";
import { w as wm } from "./components/BaseIcon/icons/plotly.svg_raw-BBAp0_mR.js";
import { w as em } from "./components/BaseIcon/icons/privacy-open.svg_raw-IC2CBbJp.js";
import { w as sm } from "./components/BaseIcon/icons/privacy-team-private.svg_raw-DpWNWHkH.js";
import { w as _m } from "./components/BaseIcon/icons/privacy-team-public.svg_raw-Ne8aWy2M.js";
import { w as pm } from "./components/BaseIcon/icons/privacy-user-private.svg_raw-DNzmV_rz.js";
import { w as bm } from "./components/BaseIcon/icons/privacy-user-public.svg_raw-DpXaEZYK.js";
import { w as lm } from "./components/BaseIcon/icons/python.svg_raw-CwVpfn1V.js";
import { w as fm } from "./components/BaseIcon/icons/pytorch.svg_raw-CDoTeX6z.js";
import { w as nm } from "./components/BaseIcon/icons/pytorch-lightning.svg_raw-DB_FbXuR.js";
import { w as cm } from "./components/BaseIcon/icons/queue.svg_raw-duRkHH6H.js";
import { w as dm } from "./components/BaseIcon/icons/queued.svg_raw-BlwBKwxK.js";
import { w as um } from "./components/BaseIcon/icons/quickstart-code.svg_raw-Chg7oFtW.js";
import { w as hm } from "./components/BaseIcon/icons/radio-tower.svg_raw-BGkDC3xy.js";
import { w as gm } from "./components/BaseIcon/icons/randomize.svg_raw-DFkgXYCX.js";
import { w as km } from "./components/BaseIcon/icons/randomize-alt.svg_raw-m_fBzQ6L.js";
import { w as ym } from "./components/BaseIcon/icons/reasoning.svg_raw-AWhil7M5.js";
import { w as vm } from "./components/BaseIcon/icons/receipt-text.svg_raw-Cbzf0k9X.js";
import { w as xm } from "./components/BaseIcon/icons/recent-clock.svg_raw-7J-Fa7Ri.js";
import { w as zm } from "./components/BaseIcon/icons/reddit-social.svg_raw-nFW5n4iy.js";
import { w as jm } from "./components/BaseIcon/icons/redo.svg_raw-B0Qax_Dm.js";
import { w as qm } from "./components/BaseIcon/icons/regex.svg_raw-fj_gqTxl.js";
import { w as Im } from "./components/BaseIcon/icons/registries.svg_raw-Cm_qjK5B.js";
import { w as Am } from "./components/BaseIcon/icons/reload-refresh.svg_raw-C8PxeAJx.js";
import { w as Cm } from "./components/BaseIcon/icons/remove.svg_raw-ygihDdsG.js";
import { w as Mm } from "./components/BaseIcon/icons/remove-alt.svg_raw-BvRvCk7B.js";
import { w as Nm } from "./components/BaseIcon/icons/report.svg_raw-lA3VhLw-.js";
import { w as Om } from "./components/BaseIcon/icons/reset.svg_raw-CMKbnDy7.js";
import { w as Pm } from "./components/BaseIcon/icons/retry-swap.svg_raw-B4-NhsZh.js";
import { w as Bm } from "./components/BaseIcon/icons/robot-service-member.svg_raw-rZr4wyyE.js";
import { w as Dm } from "./components/BaseIcon/icons/rocket-launch.svg_raw-CwICbnEk.js";
import { w as Em } from "./components/BaseIcon/icons/rowheight-l.svg_raw-cREfcd9z.js";
import { w as Fm } from "./components/BaseIcon/icons/rowheight-m.svg_raw-DxvZsuaY.js";
import { w as Gm } from "./components/BaseIcon/icons/rowheight-s.svg_raw-D9exfxij.js";
import { w as Hm } from "./components/BaseIcon/icons/rowheight-xl.svg_raw-Dl4siaas.js";
import { w as Jm } from "./components/BaseIcon/icons/run-set-subset.svg_raw-DsHOJf8b.js";
import { w as Km } from "./components/BaseIcon/icons/run-set-universe.svg_raw-CkOGPjm5.js";
import { w as Lm } from "./components/BaseIcon/icons/running-repeat.svg_raw-m_fBzQ6L.js";
import { w as Qm } from "./components/BaseIcon/icons/sandbox-playground.svg_raw-nsigZ2vj.js";
import { w as Rm } from "./components/BaseIcon/icons/save.svg_raw-Dw8b3tjJ.js";
import { w as Sm } from "./components/BaseIcon/icons/scale-down.svg_raw-B8t-o7Qx.js";
import { w as Tm } from "./components/BaseIcon/icons/scale-up.svg_raw-0d0CduCw.js";
import { w as Um } from "./components/BaseIcon/icons/scikit.svg_raw-BOnPQJiO.js";
import { w as Vm } from "./components/BaseIcon/icons/search.svg_raw-N3kNJuiB.js";
import { w as Wm } from "./components/BaseIcon/icons/search-results.svg_raw-Cw6FV5rY.js";
import { w as Xm } from "./components/BaseIcon/icons/section.svg_raw-CSm6EZtf.js";
import { w as Ym } from "./components/BaseIcon/icons/seed-propagate.svg_raw-DN2MI5KS.js";
import { w as Zm } from "./components/BaseIcon/icons/select-marquee-tool.svg_raw-DV6sBMIj.js";
import { w as $m } from "./components/BaseIcon/icons/select-move-tool.svg_raw-C98RFhaa.js";
import { w as oi } from "./components/BaseIcon/icons/settings.svg_raw-BxvFiRbC.js";
import { w as ri } from "./components/BaseIcon/icons/settings-parameters.svg_raw-Dez9ZQB7.js";
import { w as ai } from "./components/BaseIcon/icons/shield-protected.svg_raw-BDw0-46j.js";
import { w as ti } from "./components/BaseIcon/icons/shield-remove.svg_raw-fWhz_Lss.js";
import { w as mi } from "./components/BaseIcon/icons/shopping-cart.svg_raw-CU_B24AH.js";
import { w as ii } from "./components/BaseIcon/icons/sidebar.svg_raw-BYIpQe7v.js";
import { w as wi } from "./components/BaseIcon/icons/sidebar-collapse.svg_raw-CTjtmCtZ.js";
import { w as ei } from "./components/BaseIcon/icons/sidebar-reveal.svg_raw-Cya8Nghr.js";
import { w as si } from "./components/BaseIcon/icons/slack.svg_raw-DvH2qTKH.js";
import { w as _i } from "./components/BaseIcon/icons/smoothing.svg_raw-DRm7enlr.js";
import { w as pi } from "./components/BaseIcon/icons/sort.svg_raw-B9WP6dJg.js";
import { w as bi } from "./components/BaseIcon/icons/sort-direction.svg_raw-CwLAl57p.js";
import { w as li } from "./components/BaseIcon/icons/spiral.svg_raw-BO0IihH7.js";
import { w as fi } from "./components/BaseIcon/icons/split.svg_raw-D-9zQ_qJ.js";
import { w as ni } from "./components/BaseIcon/icons/square.svg_raw-CIotYDuG.js";
import { w as ci } from "./components/BaseIcon/icons/star.svg_raw-nQVLyVZx.js";
import { w as di } from "./components/BaseIcon/icons/star-filled.svg_raw-DEpfBTGJ.js";
import { w as ui } from "./components/BaseIcon/icons/stop.svg_raw-CIotYDuG.js";
import { w as hi } from "./components/BaseIcon/icons/stopped.svg_raw-BiBmL4yt.js";
import { w as gi } from "./components/BaseIcon/icons/strikethrough.svg_raw-S9UG_GKc.js";
import { w as ki } from "./components/BaseIcon/icons/sun.svg_raw-BkPiZgFS.js";
import { w as yi } from "./components/BaseIcon/icons/sweep-bayes.svg_raw-C7szutJp.js";
import { w as vi } from "./components/BaseIcon/icons/sweep-grid.svg_raw--ffJMfYu.js";
import { w as xi } from "./components/BaseIcon/icons/sweep-random-search.svg_raw-CYIBPh8j.js";
import { w as zi } from "./components/BaseIcon/icons/sweeps-alt.svg_raw-uc8lk79K.js";
import { w as ji } from "./components/BaseIcon/icons/sweeps-broom.svg_raw-CrehbuKV.js";
import { w as qi } from "./components/BaseIcon/icons/switch-account.svg_raw-DxILYRC3.js";
import { w as Ii } from "./components/BaseIcon/icons/system.svg_raw-BXPLNqrv.js";
import { w as Ai } from "./components/BaseIcon/icons/system-chip.svg_raw-QL0lfZdq.js";
import { w as Ci } from "./components/BaseIcon/icons/system-chip-alt.svg_raw-RQ94XcyS.js";
import { w as Mi } from "./components/BaseIcon/icons/table.svg_raw-D9sspCSg.js";
import { w as Ni } from "./components/BaseIcon/icons/tablet-responsive.svg_raw-nHVWbOGv.js";
import { w as Oi } from "./components/BaseIcon/icons/tag.svg_raw-D4hghg8b.js";
import { w as Pi } from "./components/BaseIcon/icons/tensorflow.svg_raw-BfrHW5Xi.js";
import { w as Bi } from "./components/BaseIcon/icons/text-language.svg_raw-1Z_HAkW5.js";
import { w as Di } from "./components/BaseIcon/icons/text-language-alt.svg_raw-z8L_Zkda.js";
import { w as Ei } from "./components/BaseIcon/icons/threads.svg_raw-C351SwBK.js";
import { w as Fi } from "./components/BaseIcon/icons/thumbs-down.svg_raw-GEcbx9CY.js";
import { w as Gi } from "./components/BaseIcon/icons/thumbs-up.svg_raw-D3iq7B9A.js";
import { w as Hi } from "./components/BaseIcon/icons/token.svg_raw-ta4vJua6.js";
import { w as Ji } from "./components/BaseIcon/icons/treeview.svg_raw-D7k0W4x4.js";
import { w as Ki } from "./components/BaseIcon/icons/triangle-alert.svg_raw-CNNC99d1.js";
import { w as Li } from "./components/BaseIcon/icons/triangle-down.svg_raw--QBtnOfe.js";
import { w as Qi } from "./components/BaseIcon/icons/triangle-left.svg_raw-DqrZkR6k.js";
import { w as Ri } from "./components/BaseIcon/icons/triangle-right.svg_raw-Bgf4D5Pj.js";
import { w as Si } from "./components/BaseIcon/icons/triangle-up.svg_raw-D-5WTkzA.js";
import { w as Ti } from "./components/BaseIcon/icons/truck.svg_raw-SW__rPG0.js";
import { w as Ui } from "./components/BaseIcon/icons/type-boolean.svg_raw-B8hOzPJn.js";
import { w as Vi } from "./components/BaseIcon/icons/type-number.svg_raw-DUi3RZCF.js";
import { w as Wi } from "./components/BaseIcon/icons/type-number-alt.svg_raw-B_sVPG4b.js";
import { w as Xi } from "./components/BaseIcon/icons/type-string-alt.svg_raw-hO5Di_Uj.js";
import { w as Yi } from "./components/BaseIcon/icons/type-string-quote.svg_raw-CBNx6gu1.js";
import { w as Zi } from "./components/BaseIcon/icons/unassigned-01.svg_raw-Bp2j0ESl.js";
import { w as $i } from "./components/BaseIcon/icons/unassigned-02.svg_raw-D_Tk0CFX.js";
import { w as ow } from "./components/BaseIcon/icons/undo.svg_raw-D3XXjLsc.js";
import { w as rw } from "./components/BaseIcon/icons/undock.svg_raw-F0Xal5d0.js";
import { w as aw } from "./components/BaseIcon/icons/unified-diff.svg_raw-z4V5vKn1.js";
import { w as tw } from "./components/BaseIcon/icons/unlocked-unconstrained.svg_raw-DuGNPSL3.js";
import { w as mw } from "./components/BaseIcon/icons/up.svg_raw-COFuWyxH.js";
import { w as iw } from "./components/BaseIcon/icons/user-author.svg_raw-CR31TrBE.js";
import { w as ww } from "./components/BaseIcon/icons/user-profile-personal.svg_raw-S4tC62Sg.js";
import { w as ew } from "./components/BaseIcon/icons/users-team.svg_raw-CWQgiazd.js";
import { w as sw } from "./components/BaseIcon/icons/uuid-identifier.svg_raw-HR-xastS.js";
import { w as _w } from "./components/BaseIcon/icons/versions-layers.svg_raw-CINRm_TB.js";
import { w as pw } from "./components/BaseIcon/icons/vertex-gcp.svg_raw-sq7iAfkv.js";
import { w as bw } from "./components/BaseIcon/icons/video-play.svg_raw-CpQPwXzy.js";
import { w as lw } from "./components/BaseIcon/icons/view-alt.svg_raw-CEQxw0Cd.js";
import { w as fw } from "./components/BaseIcon/icons/view-collapse.svg_raw-D8PSJkbS.js";
import { w as nw } from "./components/BaseIcon/icons/view-expand.svg_raw-CcBmQ1da.js";
import { w as cw } from "./components/BaseIcon/icons/view-glasses.svg_raw-ZtiWSUcd.js";
import { w as dw } from "./components/BaseIcon/icons/visibility-checked.svg_raw-kydBmqh4.js";
import { w as uw } from "./components/BaseIcon/icons/visibility-indeterminate.svg_raw-C34-Bq8S.js";
import { w as hw } from "./components/BaseIcon/icons/visibility-unchecked.svg_raw-Ck1l_Ir2.js";
import { w as gw } from "./components/BaseIcon/icons/volleyball.svg_raw-pm7aifuj.js";
import { w as kw } from "./components/BaseIcon/icons/wandb.svg_raw-De6VMFoy.js";
import { w as yw } from "./components/BaseIcon/icons/wandb-alt.svg_raw-CKgkXOyJ.js";
import { w as vw } from "./components/BaseIcon/icons/warning.svg_raw-BZSb_XRe.js";
import { w as xw } from "./components/BaseIcon/icons/weave.svg_raw-CnB0-yJl.js";
import { w as zw } from "./components/BaseIcon/icons/webhook.svg_raw-CVL8hiVF.js";
import { w as jw } from "./components/BaseIcon/icons/webhook-alt.svg_raw-CVqvlTs3.js";
import { w as qw } from "./components/BaseIcon/icons/wrap.svg_raw-Ccj_xsH8.js";
import { w as Iw } from "./components/BaseIcon/icons/wrench.svg_raw-XLseoDpN.js";
import { w as Aw } from "./components/BaseIcon/icons/x-axi-alt.svg_raw-CcUxOGWk.js";
import { w as Cw } from "./components/BaseIcon/icons/x-axis.svg_raw-hVvsplEZ.js";
import { w as Mw } from "./components/BaseIcon/icons/x-social.svg_raw-D5wChvKi.js";
import { w as Nw } from "./components/BaseIcon/icons/youtube-social.svg_raw-DSXkvcue.js";
import { w as Ow } from "./components/BaseIcon/icons/zoom-alt-tool.svg_raw-CiDAdAn0.js";
import { w as Pw } from "./components/BaseIcon/icons/zoom-in-tool.svg_raw-BfrzfrQg.js";
import { w as Bw } from "./components/BaseIcon/icons/zoom-out-tool.svg_raw-CB-wCi6b.js";
const un = {
  "1x": o,
  "2x": r,
  "4x": a,
  activity: t,
  "add-comment": m,
  "add-comments-round-alt": i,
  "add-new": w,
  "add-panel": e,
  "add-reaction": s,
  "add-to-report": _,
  "admin-shield-safe": p,
  "agent-stop": b,
  "alias-alt": l,
  "alias-protected": f,
  "amazon-sagemaker": n,
  aperture: c,
  apps: d,
  "arrow-up-from-line": u,
  "artifact-type": h,
  "artifact-type-alt": g,
  attachment: k,
  "audio-volume": y,
  "automation-robot-arm": v,
  baby: x,
  back: z,
  "baseline-alt": j,
  "bell-notifications": q,
  "benchmark-square": I,
  bike: A,
  "blog-alt": C,
  "blog-report": M,
  bokeh: N,
  bold: O,
  "book-dictionary": P,
  bookmark: B,
  "bookmark-filled": D,
  "bookmark-my-projects": E,
  "brain-circuit": F,
  "branch-commit": G,
  bug: H,
  "bulk-panel-alt": J,
  "buzz-bot": K,
  "camera-photo": L,
  "caret-close": Q,
  "caret-open": R,
  "category-multimodal": S,
  "chart-area": T,
  "chart-area-alt": U,
  "chart-area-percentage": V,
  "chart-box-plot": W,
  "chart-ema-exponential": X,
  "chart-horizontal-bars": Y,
  "chart-line": Z,
  "chart-line-plot": $,
  "chart-line-plot-down": oo,
  "chart-line-plot-multi": ro,
  "chart-linear-scale": ao,
  "chart-loess": to,
  "chart-logarithmic": mo,
  "chart-parallel-coordinates": io,
  "chart-pie": wo,
  "chart-scatterplot": eo,
  "chart-time-weighted-ema": so,
  "chart-vertical-bars": _o,
  checkmark: po,
  "checkmark-alt": bo,
  "checkmark-circle": lo,
  checkmark2: fo,
  "chevron-back": no,
  "chevron-down": co,
  "chevron-next": uo,
  "chevron-up": ho,
  circle: go,
  "circle-bold": ko,
  "circle-dollar-sign": yo,
  "circle-filled": vo,
  "clear-all": xo,
  close: zo,
  cloud: jo,
  "cloud-download": qo,
  "cloud-upload": Io,
  "code-alt": Ao,
  "code-html": Co,
  "code-json": Mo,
  colab: No,
  collapse: Oo,
  collection: Po,
  color: Bo,
  "color-palette": Do,
  column: Eo,
  "column-alt": Fo,
  combine: Go,
  comments: Ho,
  "comments-alt": Jo,
  "comments-round-alt": Ko,
  "compass-baseline": Lo,
  "compass-baseline-alt": Qo,
  compose: Ro,
  condition: So,
  "content-full-width": To,
  "content-narrow": Uo,
  "content-wide": Vo,
  "context-window": Wo,
  copy: Xo,
  cost: Yo,
  "courthouse-license": Zo,
  "credit-card-payment": $o,
  "crop-beginning": or,
  "crop-end": rr,
  "crop-middle": ar,
  cross: tr,
  "crown-pro": mr,
  "cube-container": ir,
  "curly-brackets": wr,
  dag: er,
  "dashboard-blackboard": sr,
  "database-artifacts": _r,
  date: pr,
  delete: br,
  "desktop-responsive": lr,
  diamond: fr,
  "diamond-pro": nr,
  diff: cr,
  "discord-social": dr,
  "do-not-prohibited": ur,
  "doc-left": hr,
  "dock-arrow": gr,
  "docker-whale": kr,
  document: yr,
  documentation: vr,
  down: xr,
  download: zr,
  "draft-manual": jr,
  "drag-grip": qr,
  dumbbell: Ir,
  "education-academic": Ar,
  "email-at": Cr,
  "email-envelope": Mr,
  "enter-return": Nr,
  "enter-switch": Or,
  "enterprise-corporate": Pr,
  "expand-down": Br,
  "expand-left": Dr,
  "expand-right": Er,
  "expand-uncollapse": Fr,
  "expand-up": Gr,
  explosion: Hr,
  "export-share-upload": Jr,
  extract: Kr,
  "extract-break": Lr,
  "facebook-social": Qr,
  factory: Rr,
  "failed-error-deleted": Sr,
  feather: Tr,
  "feather-alt": Ur,
  "filter-alt": Vr,
  "flash-bolt": Wr,
  "folder-eye": Xr,
  "folder-fill": Yr,
  "folder-project": Zr,
  "folder-project-move": $r,
  footprints: oa,
  "forum-chat-bubble": ra,
  "forward-next": aa,
  "freeze-snowflake": ta,
  "freeze-snowflake-alt": ma,
  "full-screen-mode-expand": ia,
  "ghost-agent": wa,
  git: ea,
  github: sa,
  grafana: _a,
  "grafana-mono": pa,
  group: ba,
  "hand-fist": la,
  "hand-manual": fa,
  headset: na,
  heart: ca,
  "heart-filled": da,
  "help-alt": ua,
  "help-resources": ha,
  hide: ga,
  history: ka,
  home: ya,
  hospital: va,
  hourglass: xa,
  "hourglass-alt": za,
  idle: ja,
  "ignore-outliers": qa,
  "impersonate-mask": Ia,
  "impersonate-mask-alt": Aa,
  "import-corner-arrow": Ca,
  "import-insert": Ma,
  "individual-controls-alt": Na,
  inference: Oa,
  "infinity-auto": Pa,
  info: Ba,
  isolate: Da,
  italic: Ea,
  "job-automation": Fa,
  "job-calculator": Ga,
  "job-program-code": Ha,
  keras: Ja,
  "key-admin": Ka,
  "key-admin-private": La,
  keyboard: Qa,
  kubernetes: Ra,
  languages: Sa,
  "laptop-local-computer": Ta,
  "layout-grid": Ua,
  "layout-horizontal": Va,
  "layout-mixed": Wa,
  "layout-split": Xa,
  "layout-tabs": Ya,
  "layout-vertical": Za,
  leaf: $a,
  lightboard: ot,
  "lightboard-solid": rt,
  "lightbulb-info": at,
  "linear-scale-1": tt,
  "link-alt": mt,
  "list-bullets": it,
  "list-bullets-alt": wt,
  "list-numbered": et,
  listing: st,
  loading: _t,
  "location-pin": pt,
  "lock-closed": bt,
  "lock-open": lt,
  "locked-constrained": ft,
  "log-in": nt,
  "log-out": ct,
  "log-scale-x": dt,
  "log-scale-y": ut,
  "magic-wand-star": ht,
  "magic-wand-stick": gt,
  marimo: kt,
  marker: yt,
  megaphone: vt,
  menu: xt,
  "microphone-audio": zt,
  "miller-columns": jt,
  "minimize-mode": qt,
  "mobile-responsive": It,
  model: At,
  molecule: Ct,
  monitors: Mt,
  moon: Nt,
  "multi-select": Ot,
  "music-audio": Pt,
  "new-section-above": Bt,
  "new-section-below": Dt,
  notebook: Et,
  "number-hashtag": Ft,
  "open-new-tab": Gt,
  "orchestration-launch": Ht,
  "organization-corporate": Jt,
  "overflow-horizontal": Kt,
  "pan-tool": Lt,
  "pan-tool-1": Qt,
  panel: Rt,
  "panel-auto-gen": St,
  "panel-hide-icon-closed-eye": Tt,
  "panel-manual": Ut,
  paragraph: Vt,
  "parent-back-up": Wt,
  "party-popper": Xt,
  pause: Yt,
  paused: Zt,
  "pencil-edit": $t,
  phone: om,
  "photo-picture": rm,
  pin: am,
  "pin-filled": tm,
  plane: mm,
  play: im,
  plotly: wm,
  "privacy-open": em,
  "privacy-team-private": sm,
  "privacy-team-public": _m,
  "privacy-user-private": pm,
  "privacy-user-public": bm,
  python: lm,
  pytorch: fm,
  "pytorch-lightning": nm,
  queue: cm,
  queued: dm,
  "quickstart-code": um,
  "radio-tower": hm,
  randomize: gm,
  "randomize-alt": km,
  reasoning: ym,
  "receipt-text": vm,
  "recent-clock": xm,
  "reddit-social": zm,
  redo: jm,
  regex: qm,
  registries: Im,
  "reload-refresh": Am,
  remove: Cm,
  "remove-alt": Mm,
  report: Nm,
  reset: Om,
  "retry-swap": Pm,
  "robot-service-member": Bm,
  "rocket-launch": Dm,
  "rowheight-l": Em,
  "rowheight-m": Fm,
  "rowheight-s": Gm,
  "rowheight-xl": Hm,
  "run-set-subset": Jm,
  "run-set-universe": Km,
  "running-repeat": Lm,
  "sandbox-playground": Qm,
  save: Rm,
  "scale-down": Sm,
  "scale-up": Tm,
  scikit: Um,
  search: Vm,
  "search-results": Wm,
  section: Xm,
  "seed-propagate": Ym,
  "select-marquee-tool": Zm,
  "select-move-tool": $m,
  settings: oi,
  "settings-parameters": ri,
  "shield-protected": ai,
  "shield-remove": ti,
  "shopping-cart": mi,
  sidebar: ii,
  "sidebar-collapse": wi,
  "sidebar-reveal": ei,
  slack: si,
  smoothing: _i,
  sort: pi,
  "sort-direction": bi,
  spiral: li,
  split: fi,
  square: ni,
  star: ci,
  "star-filled": di,
  stop: ui,
  stopped: hi,
  strikethrough: gi,
  sun: ki,
  "sweep-bayes": yi,
  "sweep-grid": vi,
  "sweep-random-search": xi,
  "sweeps-alt": zi,
  "sweeps-broom": ji,
  "switch-account": qi,
  system: Ii,
  "system-chip": Ai,
  "system-chip-alt": Ci,
  table: Mi,
  "tablet-responsive": Ni,
  tag: Oi,
  tensorflow: Pi,
  "text-language": Bi,
  "text-language-alt": Di,
  threads: Ei,
  "thumbs-down": Fi,
  "thumbs-up": Gi,
  token: Hi,
  treeview: Ji,
  "triangle-alert": Ki,
  "triangle-down": Li,
  "triangle-left": Qi,
  "triangle-right": Ri,
  "triangle-up": Si,
  truck: Ti,
  "type-boolean": Ui,
  "type-number": Vi,
  "type-number-alt": Wi,
  "type-string-alt": Xi,
  "type-string-quote": Yi,
  "unassigned-01": Zi,
  "unassigned-02": $i,
  undo: ow,
  undock: rw,
  "unified-diff": aw,
  "unlocked-unconstrained": tw,
  up: mw,
  "user-author": iw,
  "user-profile-personal": ww,
  "users-team": ew,
  "uuid-identifier": sw,
  "versions-layers": _w,
  "vertex-gcp": pw,
  "video-play": bw,
  "view-alt": lw,
  "view-collapse": fw,
  "view-expand": nw,
  "view-glasses": cw,
  "visibility-checked": dw,
  "visibility-indeterminate": uw,
  "visibility-unchecked": hw,
  volleyball: gw,
  wandb: kw,
  "wandb-alt": yw,
  warning: vw,
  weave: xw,
  webhook: zw,
  "webhook-alt": jw,
  wrap: qw,
  wrench: Iw,
  "x-axi-alt": Aw,
  "x-axis": Cw,
  "x-social": Mw,
  "youtube-social": Nw,
  "zoom-alt-tool": Ow,
  "zoom-in-tool": Pw,
  "zoom-out-tool": Bw
};
export {
  un as I
};
